const constants: any = {
	LIGHT: "light",
	RULES: [
		"There are 10 questions and each question carries 10 points.",
		"Questions are in the form of multipe choice.",
		"Every questions has only 1 correct answer.",
		"To pass, score more than 60 points.",
	],
	UNAUTHORIZED: 401,
	EMAIL_ALREADY_IN_USE: 409,
};

export { constants };
